module.exports = __webpack_public_path__ + "static/6-d1bb45cf4b7d820c265bbec49d6a2a27.png";